<template>
    <div class="p-4 bg-gray-50 border border-gray-200 rounded-xl">
        <ui-form-section class="mb-4">
            <ui-select-searchable
                label="Current Driver"
                v-model="form.driver"
                :error="form.errors.get('driver_id')"
                :search="searchContact"
            ></ui-select-searchable>
        </ui-form-section>
        <div class="flex justify-end space-x-4">
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Update Driver</ui-button-new>
        </div>
    </div>
</template>

<script>
import { Contact } from '@models'

export default {
    props: {
        vehicle: Object,
    },
    data () {
        return {
            form: new Form(this.vehicle.getFormAttributes(), async (form) => {
                await this.vehicle.update(form.export())
            }),
        }
    },
    methods: {
        async searchContact (query) {
            return (await Contact.search(query)).map(x => x.toDropdown())
        },
    },
}
</script>
